<template>
    <v-dialog width="500px" :value="value" @input="toggleModal" persistent scrollable>
        <v-card class="kbLight">
            <v-toolbar class="kbGold" dark text flat>
                <div class="text-h6">{{$t('general.registerAttender')}}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-container class="pa-0" fluid>
                    <v-row>
                        <v-col cols="12">
                            <v-select :label="$t('general.event')"
                                      color="kbDarkBlue"
                                      :items="events"
                                      item-text="title"
                                      v-model="event"
                                      return-object
                                      @change="ticket = ''">
                            </v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-select :label="$t('general.ticket')"
                                      color="kbDarkBlue"
                                      :items="event.tickets"
                                      :disabled="!event"
                                      item-text="title"
                                      v-model="ticket"
                                      return-object>
                            </v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field :label="$t('general.name')"
                                          color="kbDarkBlue"
                                          v-model="attendee.name"></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field :label="$t('general.document')"
                                          color="kbDarkBlue"
                                          v-model="attendee.document"></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field :label="$t('general.email')"
                                          color="kbDarkBlue"
                                          v-model="attendee.email"></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field :label="$t('general.phone')"
                                          color="kbDarkBlue"
                                          v-model="attendee.phone"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mr-2" color="red" outlined @click="cancelNew">{{$t('general.cancel')}}</v-btn>
                <v-btn color="kbGold" dark @click="submit" :loading="loading">{{$t('general.register')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'

export default {
  computed: {
    ...mapState({
      events: state => state.events.events
    })
  },
  created () {
    this.$store.dispatch('getEvents')
  },
  data () {
    return {
      loading: false,
      attendee: {
        name: '',
        document: '',
        email: '',
        phone: '',
        country: 'co'
      },
      event: '',
      ticket: ''
    }
  },
  methods: {
    submit () {
      this.createAttendee()
    },
    createAttendee () {
      this.loading = true
      const data = {
        attendees: [{ ...this.attendee }],
        eventId: this.event._id,
        ticketId: this.ticket._id,
        price: this.ticket.price
      }
      this.$store.dispatch('createAttendee', data).then(() => {
        this.resetAttendee()
        this.$emit('input', false)
        this.loading = false
        notifications.success(this.$t('general.assistantRegistered'))
      }).catch(error => {
        this.loading = false
        notifications.error(error.message)
      })
    },
    cancelNew () {
      this.resetAttendee()
      this.$emit('input', false)
    },
    resetAttendee () {
      this.attendee = {
        name: '',
        email: ''
      }
    },
    toggleModal (value) {
      this.resetAttendee()
      this.$emit('input', value)
    }
  },
  props: ['value']
}
</script>
